<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="平台编码">
            <platformSelecter :platformcode="searchP.platformcode"  @platformChange="handlePlatformChange"></platformSelecter>
        </a-form-item>
        <a-form-item label="所属目录">
            <catalog :mmkey="searchP.catalogcode" :platformcode="searchP.platformcode"  @catalogcodechange="handleCatlogChange" ></catalog>
        </a-form-item>

        <a-form-item label="关键字">
            <a-input v-model="searchP.keyword" placeholder="关键字"></a-input>
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import catalog from '../com/catalog'
import platformSelecter from '../com/platformSelecter'

export default {
    components:{
        catalog,
        platformSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                platformcode:'',
                catalogcode:'',
                keyword:'',
                platformlist:[]
            }
        }
    },
    methods:{
        handleCatlogChange(v){
            this.searchP.catalogcode = v;
        },
        handlePlatformChange(obj){
            this.searchP.platformcode = obj.platformcode;
            this.searchP.platformlist = obj.platformlist;
            this.handleSubmit();
        },
        handleSubmit(){
            this.$store.commit("save", {searchP_configmanager: this.searchP})
            this.$emit("handleSearch",this.searchP);
        },
      
    },
    mounted(){
        let searchP = this.$store.state.searchP_configmanager
        if(searchP){
            this.searchP = searchP
        }
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

